import React from 'react';
import {
  MenuItem,
  Select as MUISelect,
  withStyles,
  Typography,
  makeStyles,
} from '@material-ui/core';
import styled from 'styled-components';

import { SvgIcon } from 'Components/Base';
import { LEARNING_MODE } from 'Context/ClassroomContext';

import { setDefaultModeToBeTheFirstIndex } from '../Utils/LearningModeSorter';

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: '250px',
  },
}));

const SelectMenuItem = styled((props) => <MenuItem p={0} {...props} />)`
  padding-left: ${({ theme }) => `${theme.space[2]}px !important`};
  font-family: ${({ theme }) => `${theme.fonts.sans} !important`};
  font-size: ${({ theme }) => `${theme.fontSizes[1]} !important`};
  font-weight: ${({ theme }) => `${theme.fontWeights.medium} !important`};
`;

const Select = styled((props) => <MUISelect {...props} />)`
  width: 100%;
  padding-left: ${({ theme }) => `${theme.space[1]}px`};
  font-family: ${({ theme }) => `${theme.fonts.sans} !important`};
  border-radius: ${({ theme }) => `${theme.space[2]}px !important`};
  padding-right: ${({ theme }) => `${theme.space[0]}px !important`};
`;

const LearningModeOptionSelector = withStyles((theme) => {
  return {
    root: {
      paddingTop: 9,
      paddingBottom: 9,
      fontSize: theme.typography.fontSize,
      fontWeight: theme.typography.fontWeightMedium,
    },
    icon: {
      marginRight: 13,
      fontSize: 25,
      color: 'black',
    },
  };
})(({ classes, ...props }) => {
  const { currentLearningMode, handleLearningModeSelection, learningModeDetailOptions } = props;

  const handleOnchange = (e) => {
    const selectedLearningMode = e.target.value;
    handleLearningModeSelection(selectedLearningMode);
  };

  const useStyleClasses = useStyles();

  const sortedLearningModeDetailOptions =
    setDefaultModeToBeTheFirstIndex(learningModeDetailOptions);

  return (
    <Select
      MenuProps={{
        classes: { paper: useStyleClasses.paper },
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: -1,
          horizontal: 'left',
        },
      }}
      variant="outlined"
      value={currentLearningMode}
      IconComponent={SvgIcon.ICON_LIST.ARROW_DOWN}
      onChange={handleOnchange}
      displayEmpty
      classes={{
        root: classes.root,
        outlined: classes.outlined,
        icon: classes.icon,
      }}
      {...props}
    >
      {sortedLearningModeDetailOptions.map((learningMode) => {
        return (
          <SelectMenuItem key={learningMode.id} value={learningMode.id}>
            <Typography variant="inherit" noWrap>
              {learningMode.name === LEARNING_MODE.DEFAULT ? 'ทั่วไป' : learningMode.name}
            </Typography>
          </SelectMenuItem>
        );
      })}
    </Select>
  );
});

export default LearningModeOptionSelector;
